import { BalloonIcon } from './BalloonIcon';

/**
 * author: Michael Richins
 * id 31D1D255-3E73-41A8-93E2-12DF16DA0C40
 * name balloon
 * version: 2.6.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/balloon.svg
 * tags
 * - Holiday 
 */
export const PartyBalloonIcon = BalloonIcon;
export default PartyBalloonIcon